import { render, staticRenderFns } from "./kucun.vue?vue&type=template&id=33aa3a47&scoped=true"
import script from "./kucun.vue?vue&type=script&lang=js"
export * from "./kucun.vue?vue&type=script&lang=js"
import style0 from "./kucun.vue?vue&type=style&index=0&id=33aa3a47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa3a47",
  null
  
)

export default component.exports